import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiUrl,brands } from "../../../config/config";

const Footer = () => {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch categories
        const categoriesResponse = await fetch(`${apiUrl}/api/${brands}/category`);
        const categoriesData = await categoriesResponse.json();
        
        // Fetch products
        const productsResponse = await fetch(`${apiUrl}/api/${brands}/products`);
        const productsData = await productsResponse.json();
        
        setCategories(categoriesData.data);
        setProducts(productsData.data);
      } catch (error) {
        console.error('Error fetching footer data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Helper function to create URL-friendly string
  const createUrlString = (text) => {
    return text
      .toUpperCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-');
  };

if (loading) {
  return (
    <footer className="bg-[#1F1F1F] text-white pt-20 pb-10 px-6 lg:px-20">
      
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 animate-pulse">

        {/* COLUMN 1 */}
        <div>
          <div className="h-5 bg-gray-500 rounded w-40 mb-4"></div>
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-3 bg-gray-600 rounded w-32 mb-2"></div>
          ))}
        </div>

        {/* COLUMN 2 */}
        <div>
          <div className="h-5 bg-gray-500 rounded w-40 mb-4"></div>
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-3 bg-gray-600 rounded w-36 mb-2"></div>
          ))}
        </div>

        {/* COLUMN 3 */}
        <div>
          <div className="h-5 bg-gray-500 rounded w-40 mb-4"></div>
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-3 bg-gray-600 rounded w-28 mb-2"></div>
          ))}
        </div>

        {/* COLUMN 4 (Contact) */}
        <div>
          <div className="h-5 bg-gray-500 rounded w-40 mb-4"></div>

          <div className="h-3 bg-gray-600 rounded w-24 mb-2"></div>
          <div className="h-3 bg-gray-500 rounded w-32 mb-4"></div>

          <div className="h-3 bg-gray-600 rounded w-20 mb-2"></div>
          <div className="h-3 bg-gray-500 rounded w-40"></div>
        </div>

      </div>

      {/* Bottom section skeleton */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 mt-10 animate-pulse">

        {Array.from({ length: 3 }).map((_, col) => (
          <div key={col}>
            <div className="h-5 bg-gray-500 rounded w-40 mb-4"></div>

            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="h-3 bg-gray-600 rounded w-32 mb-2"></div>
            ))}
          </div>
        ))}

      </div>

      <div className="h-10"></div>

    </footer>
  );
}

  return (
    <footer className="bg-[#1F1F1F] text-white pt-20 pb-10 px-6 lg:px-20">

      {/* ========== TOP FOOTER GRID ========== */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">

        {/* CUSTOM STYLES */}
        <div>
          <h3 className="text-lg font-semibold mb-4">CUSTOM STYLES</h3>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><span className="cursor-not-allowed opacity-60">Iron On Patches</span></li>
            <li><span className="cursor-not-allowed opacity-60">Morale Patches</span></li>
            <li><span className="cursor-not-allowed opacity-60">Army Patches</span></li>
            <li><span className="cursor-not-allowed opacity-60">Motorcycle Patches</span></li>
            <li><span className="cursor-not-allowed opacity-60">Military Patches</span></li>
            <li><span className="cursor-not-allowed opacity-60">Tactical Patches</span></li>
            <li><span className="cursor-not-allowed opacity-60">Police Patches</span></li>
            <li><span className="cursor-not-allowed opacity-60">Girl Scout Patches</span></li>
            <li><span className="cursor-not-allowed opacity-60">Funny Patches</span></li>
            <li><span className="cursor-not-allowed opacity-60">Name Patches</span></li>
            <li><span className="cursor-not-allowed opacity-60">Custom Velcro Patches</span></li>
          </ul>
        </div>

        {/* CUSTOM PATCHES */}
        <div>
          <h3 className="text-lg font-semibold mb-4">CUSTOM PATCHES</h3>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><span className="cursor-not-allowed opacity-60">Backpack Patches</span></li>
            <li><span className="cursor-not-allowed opacity-60">Patches For Beanies</span></li>
            <li><span className="cursor-not-allowed opacity-60">Patches For Jackets</span></li>
            <li><span className="cursor-not-allowed opacity-60">Patches For Hats</span></li>
            <li><span className="cursor-not-allowed opacity-60">Patches For Clothes</span></li>
            <li><span className="cursor-not-allowed opacity-60">Patches For Shirts</span></li>
            <li><span className="cursor-not-allowed opacity-60">Patches For Hoodies</span></li>
            <li><span className="cursor-not-allowed opacity-60">Patches For Vests</span></li>
            <li><span className="cursor-not-allowed opacity-60">Patches For Pants</span></li>
            <li><span className="cursor-not-allowed opacity-60">Letterman Jacket Patches</span></li>
            <li>
              {/* <Link to="/custom-patches" className="font-semibold hover:text-white transition-colors duration-200">
                View All
              </Link> */}
            </li>
          </ul>
        </div>

        {/* OUR PRODUCTS - Dynamic from API */}
        <div>
          <h3 className="text-lg font-semibold mb-4">OUR PRODUCTS</h3>
          <ul className="space-y-2 text-sm text-gray-300">
            {products.slice(0, 11).map((product) => {
              const categoryName = createUrlString(product.category?.category_name || '');
              const productName = createUrlString(product.name);
              
              return (
                <li key={product.id}>
                  <Link 
                    to={`/product/${categoryName}/${product.category_id}/${productName}/${product.id}`}
                    className="hover:text-white transition-colors duration-200"
                  >
                    {product.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        {/* RUSHPATCH CONTACT */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Blank Patch</h3>
          <p className="text-gray-300 text-sm">Call us:</p>
          <p className="text-white font-medium text-sm mb-3">(703)-666-8193</p>

          <p className="text-gray-300 text-sm">Email:</p>
          <p className="text-white font-medium text-sm">support@blankbeanies.com</p>
        </div>
      </div>

      {/* ========== BOTTOM FOOTER ========== */}
      

      {/* Footer bottom spacing */}
      <div className="h-10"></div>

    </footer>
  );
};

export default Footer;